import { processTitleCase } from '@/helpers/utils';
import { cn, generateValidString } from '@/helpers/utils/functionality-utils';
import { useAppSelector } from '@/store/hooks';
import { TbBuildingCommunity } from 'react-icons/tb';

export const TenantInfo = ({
  containerClassName,
}: {
  containerClassName?: string;
}) => {
  const authUserData = useAppSelector((state) => state.user.authUserData.data);
  const name = authUserData?.name;
  const role = authUserData?.role;
  const logo = authUserData?.tenant?.logo;

  const isCustomer = !!authUserData?.customer?.c_id;
  const { company, first_name, last_name } =
    useAppSelector((state) => state.user.authUserData.data.customer) || {};

  return (
    <div
      className={cn(
        'flex items-center justify-center gap-2 md:gap-4',
        containerClassName,
      )}
    >
      <div className="flex size-14 items-center justify-center overflow-hidden rounded-full border">
        {logo ? (
          <img
            src={encodeURI(logo)}
            alt="Tenant Logo"
            className="size-full object-cover"
          />
        ) : (
          <TbBuildingCommunity className="text-3xl" />
        )}
      </div>
      <div className="flex h-auto flex-col justify-center">
        <div className="flex flex-col items-center justify-center md:flex-row md:justify-start">
          <div className="text-lg">
            {isCustomer
              ? company
                ? company
                : generateValidString([first_name, last_name])
              : name}
          </div>
        </div>
        <div className="text-sm font-semibold">
          {isCustomer
            ? company && generateValidString([first_name, last_name])
            : processTitleCase(role)}
        </div>
      </div>
    </div>
  );
};
